<script lang="ts">
    import { onMount } from "svelte";
    import {
        subscribe,
        getPermissionStatus,
    } from "@reperio-news/core.components/PushSubscription.svelte";
    import { fade } from "svelte/transition";

    let showSubscribe = false;

    onMount(async () => {
        if (
            window.location.href.indexOf("_reperio_admin_preview") !== -1 ||
            window.location.host !== "click.ro"
        ) {
            return;
        }

        if (!("Notification" in window)) {
            return;
        }

        let cx = localStorage.getItem("reperio_push_sub_i");
        let cxn = 0;

        if (cx !== undefined) {
            cxn = parseInt(cx, 10);
        }

        if (isNaN(cxn) || cxn > 5) {
            cxn = 0;
        }

        if (cxn < 3) {
            localStorage.setItem("reperio_push_sub_i", (cxn + 1).toString());
            return;
        }

        const lastAsk = localStorage.getItem("reperio_push_sub_last_ask");
        const currentStatus = await getPermissionStatus();

        if (
            !lastAsk ||
            new Date().getTime() - new Date(lastAsk).getTime() > 86400000 * 15
        ) {
            showSubscribe =
                currentStatus !== "granted" && currentStatus !== "denied";
        }

        if (!showSubscribe && currentStatus === "granted") {
            subscribe();
        }
    });

    //	plain const, not a TS enum: esbuild (vitePreprocess) inlines enum
    //	member reads inside the script and drops the declaration, but the
    //	template expressions below still reference it at runtime
    const NotificationResult = {
        None: 0,
        Pending: 1,
        Done: 2,
        Failed: 3,
    } as const;

    let notificationSubResult: number = NotificationResult.None;

    async function exec(doIt: boolean): Promise<void> {
        if (doIt) {
            try {
                notificationSubResult = NotificationResult.Pending;
                const t = setTimeout(() => {
                    showSubscribe = false;
                    localStorage.setItem(
                        "reperio_push_sub_last_ask",
                        new Date().toISOString()
                    );
                }, 5000);
                const res = await subscribe();
                clearTimeout(t);

                notificationSubResult = res
                    ? NotificationResult.Done
                    : NotificationResult.Failed;

                setTimeout(() => (showSubscribe = false), 500);
            } catch (e) {
                console.error(e);
            }
        } else {
            localStorage.setItem(
                "reperio_push_sub_last_ask",
                new Date().toISOString()
            );
        }

        showSubscribe = false;
    }
</script>

{#if showSubscribe}
    <div class="popup" transition:fade>
        <div class="container">
            <img src="/favicon-60.png" alt="click.ro" />

            {#if notificationSubResult === NotificationResult.None}
                Primești rapid cele mai importante știri ale zilei.
                <div class="buttons">
                    <button class="no" on:click={() => exec(false)}
                        >Nu, mulțumesc</button
                    >
                    <button class="yes" on:click={() => exec(true)}
                        >Sunt de acord</button
                    >
                </div>
            {:else if notificationSubResult === NotificationResult.Pending}
                Asigură-te că ai notificările activate in browser!
            {:else if notificationSubResult === NotificationResult.Done}
                Super! Îți trimitem rapid cele mai importante știri ale zilei!
            {:else if notificationSubResult === NotificationResult.Failed}
                Notificările browser-ului sunt dezactivate. Nu o să primești
                cele mai importante știri!
            {/if}
        </div>
    </div>
{/if}

<style lang="scss">
    .popup {
        position: fixed;
        top: 125px;
        right: 0px;
        z-index: 5;
        width: 100%;
        text-align: center;

        .container {
            width: 350px;
            height: 150px;
            margin: auto;
            background-color: #eee;
            box-shadow: 0px 1px 46px 22px rgba(0, 0, 0, 0.4);
            display: flex;
            justify-content: center;
            align-items: center;
            flex-direction: column;
            border: 1px solid rgb(189, 181, 181);
            padding: 20px;

            .buttons {
                margin-top: 10px;
                display: flex;
                justify-content: center;

                button {
                    margin-right: 10px;
                    border: none;
                    font-weight: bold;
                    background-color: #ccc;
                    cursor: pointer;
                    padding: 10px;
                }

                button:hover {
                    background-color: rgb(17, 113, 192) !important;
                    color: #fff;
                }

                button.yes {
                    background-color: rgb(25, 161, 77);
                    border-radius: 2px;
                    color: #fff;
                }
            }
        }
    }
</style>
